module.exports = __webpack_public_path__ + "static/Alejandro_Berlin_headshot_lores-2fca18ad4827cb572d2746a7332c890a.png";